export default __webpack_public_path__ + "media/samples/WAVE_KI_BODY_PORTAL-91e68fd4.jpg";